export default {"src":"/_next/static/media/bank_icon_blue.24ef7299.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};